<script setup lang="ts">
/**
 * Description riche (HTML) avec expand/collapse fluide.
 * Partagé entre /a/[slug] (description du plan) et /b/[slug] (description event).
 * Le HTML est passé déjà sanitizé par le parent.
 */
defineProps<{
  html: string;
}>();

const { t } = useI18n();

const expanded = ref(false);
const descRef = ref<HTMLElement | null>(null);
const needsTruncation = ref(false);
const fullHeight = ref(500);

onMounted(() => {
  nextTick(() => {
    if (descRef.value) {
      fullHeight.value = descRef.value.scrollHeight + 20;
      if (descRef.value.scrollHeight > 200) {
        needsTruncation.value = true;
      }
    }
  });
});
</script>

<template>
  <div class="mt-6">
    <div class="relative">
      <!-- eslint-disable vue/no-v-html -->
      <!-- Reason: HTML sanitizé par le parent avant d'être passé en prop -->
      <div
        ref="descRef"
        class="text-[#2d2e5c] dark:text-gray-300 text-base leading-relaxed prose prose-sm dark:prose-invert max-w-none overflow-hidden transition-[max-height] duration-500 ease-in-out"
        :style="{ maxHeight: expanded ? fullHeight + 'px' : '200px' }"
        v-html="html"
      />
      <!-- eslint-enable vue/no-v-html -->
      <div
        class="absolute bottom-0 left-0 right-0 h-20 bg-linear-to-t from-white dark:from-[#141414] to-transparent pointer-events-none transition-opacity duration-500"
        :class="!expanded && needsTruncation ? 'opacity-100' : 'opacity-0'"
      />
    </div>
    <div v-if="needsTruncation" class="flex justify-center mt-3">
      <button
        class="inline-flex items-center gap-1.5 px-5 py-2.5 border border-gray-200 dark:border-gray-700 rounded-xl text-sm font-medium text-[#2d2e5c] dark:text-white hover:bg-gray-50 dark:hover:bg-[#1a1a1a] transition-all"
        @click="expanded = !expanded"
      >
        {{ expanded ? t("association.publicPage.descriptionExpandable.reduire") : t("association.publicPage.descriptionExpandable.voirComplete") }}
        <UIcon
          :name="expanded ? 'i-lucide-chevron-up' : 'i-lucide-chevron-down'"
          class="size-4 transition-transform duration-300"
        />
      </button>
    </div>
  </div>
</template>
